var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalirSesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.89,
    height: 23.604,
    viewBox: "0 0 27.89 23.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictograma_-_Salir_de_sesi\\xF3n",
    "data-name": "Pictograma - Salir de sesi\\xF3n",
    transform: "translate(-359.144 -153.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4570",
    "data-name": "Trazado 4570",
    className: "cls-1",
    d: "M371.4,171.723l1.689,1.215,5.359-7.507h.006l0,0,0,0h-.006l-5.359-7.508-1.689,1.215,3.724,5.222H359.144v2.15h15.979Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4571",
    "data-name": "Trazado 4571",
    className: "cls-1",
    d: "M359.144,153.624v6.438h2.14v-4.3h23.61v19.324h-23.61v-6.44h-2.14v8.58h27.89v-23.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalirSesion);
export default __webpack_public_path__ + "static/media/salirSesion.cb58013a3f436d8f8222eabe1dc6afac.svg";
export { ForwardRef as ReactComponent };